import * as moment from 'moment';
import { areOpenAndCloseEvents } from './moment';
/* tslint:disable: no-magic-numbers */
export function transformCiqEventsResult(result) {
    var events = [];
    if (result.data && result.data.events) {
        events = result.data.events;
    }
    var mappedEvents = {};
    var mappedLength = events.length - (events.length % 2);
    for (var i = 0; i < mappedLength; i = i + 2) {
        var openTime = moment(events[i].time).utc();
        var closeTime = moment(events[i + 1].time).utc();
        var open_1 = openTime.format('HH:mm');
        var close_1 = closeTime.format('HH:mm');
        var day = openTime.format('YYYY-MM-DD');
        var dayOfWeek = openTime.weekday();
        if (!areOpenAndCloseEvents(openTime, closeTime)) {
            openTime = moment(closeTime).utc().startOf('day');
            closeTime = moment(closeTime).utc().endOf('day');
            open_1 = '00:00';
            close_1 = '23:59';
            day = closeTime.format('YYYY-MM-DD');
            dayOfWeek = closeTime.weekday();
        }
        mappedEvents[day] = {
            open: open_1,
            close: close_1,
            dayOfWeek: dayOfWeek,
            openRaw: openTime.valueOf(),
            closeRaw: closeTime.valueOf(),
        };
    }
    return mappedEvents;
}
//# sourceMappingURL=transformers.js.map